import i18n, { i18n as i18nType } from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locale/en.json'
import de from './locale/de.json'

const locales = {
  en: {
    ...en
  },
  de: {
    ...de
  }
}

let instance: i18nType | undefined

export const i18nInstance = (lang: string) => {
  if (!instance) {
    i18n.use(initReactI18next).init({
      resources: locales,
      lng: lang,
      fallbackLng: 'de',
      interpolation: {
        escapeValue: false
      }
    })
    instance = i18n
    // Screen readers pick their voice from <html lang>; use the language
    // actually rendered (an unknown cookie value falls back to German)
    const setHtmlLang = () => {
      document.documentElement.lang = i18n.resolvedLanguage ?? 'de'
    }
    setHtmlLang()
    i18n.on('languageChanged', setHtmlLang)
  }

  return instance
}
